import { Spinner } from "@/ui";

// Apple's registered return URL for the "Sign in with Apple" web (popup) flow.
// With usePopup:true the SDK resolves in the opener window and closes this popup,
// so this page only needs to exist and load same-origin. It renders a brief spinner.
export default function AppleCallback() {
  return (
    <div data-testid="apple-callback" className="flex h-screen items-center justify-center bg-background">
      <Spinner className="h-8 w-8 text-foreground" />
    </div>
  );
}
